import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
  LinkButton,
} from "../components/ui";
import { Seo } from "../lib/head";

export function Careers() {
  return (
    <>
      <Seo title="Careers — WeConsult Rx" description="We're hiring soon. Drop us a note if you'd like to work with us." path="/careers" />
    <Section>
      <Container>
        <div className="max-w-3xl">
          <Eyebrow>Careers</Eyebrow>
          <Heading level={1} className="mt-3">
            We’re hiring soon.
          </Heading>
          <Lede className="mt-6">
            We don’t have open roles right now, but if you’re a consultant
            pharmacist who codes, or a software engineer who cares about
            healthcare, we want to hear from you.
          </Lede>
          <div className="mt-8">
            <LinkButton href="mailto:careers@weconsultrx.com">Drop us a note</LinkButton>
          </div>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {[
            ["Clinical advisor", "PharmD with SNF, ASC, or dialysis consulting experience."],
            ["Founding engineer", "TypeScript · Postgres · healthcare data."],
            ["Customer success", "Onboard new consultant practices."],
          ].map(([k, v]) => (
            <Card key={k}>
              <Heading level={3}>{k}</Heading>
              <p className="mt-3 text-ink-600">{v}</p>
            </Card>
          ))}
        </div>
      </Container>
    </Section>
    </>
  );
}
